import React, { useState } from "react";
import { Box, Container, Grid } from "@mui/material";
import PageInfoTitle from "../../components/pageTitle/PageInfoTitle";
import VehicleList from "../components/vehicles/VehicleList";
import VehiclesDetails from "../components/vehicles/VehiclesDetails";
import VehicleServiceHistory from "../components/vehicles/VehicleServiceHistory";
import ManageVehicles from "../components/vehicles/ManageVehicles";
const ClientAdminVehicles = () => {
  const [selectedId, setSelectedId] = useState<any | null>(null); // track selected
  const [open, setOpen] = useState(false); // State variable to manage dialog open/close
  const [selectedRowId, setSelectedRowId] = useState<string | null>(null); // track selected row for highlight
  const handleEditVehicle = (id: any | null) => {
    setOpen(true);
    setSelectedRowId(id);
  };

  const handleCloseModal = () => {    setOpen(false);
    setSelectedRowId(null);
    setOpen(false);
  };
  return (
    <>
      {open && (
        <ManageVehicles
          open={open}
          onHide={handleCloseModal}
          title="Edit Vehicle"
          selectedVehicle={selectedRowId}
          action="edit"
          setSelectedVehicle={setSelectedRowId}
        />
      )}
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 12 }}
        sx={{ background: "#f4f4f4", paddingTop: "16px", height: "100vh" }}
      >
        <Grid
          item
          xs={12}
          md={4}
          sx={{ paddingLeft: "0px !important", paddingTop: "0px !important" }}
        >
          <Box
            sx={{
              bgcolor: "#fff",
              height: { xs: "auto", md: "100vh" },
              // border: "1px solid #d1cfcf",
              // borderRadius: "5px",
              // padding: "4px",
            }}
          >
            <VehicleList
              selectedId={selectedId}
              setSelectedId={setSelectedId}
            />
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={8}
          sx={{ paddingLeft: "16px !important", paddingTop: "0px !important" }}
        >
          <Container
            maxWidth="lg"
            sx={{
              paddingLeft: "0px !important",
              paddingRight: "0px !important",
              background: "#fff",
            }}
          >
            <Box
              sx={{
                height: { xs: "auto", md: "100vh" },
                // border: "1px solid #d1cfcf",
                // borderRadius: "5px",
                paddingLeft: "0px !important",
                paddingRight: "0px !important",
                // padding: "0px 16px",
                overflow: "scroll",
              }}
            >
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  bgcolor: "#fff",
                  zIndex: 1,
                  border: "1px solid #C4CDD5",
                }}
              >
                <PageInfoTitle
                  title="Vehicle Details"
                  // button={selectedId ? "Edit" : ""}
                  // onClick={() => handleEditVehicle(selectedId)}
                />
              </Box>
              <Box
                sx={{
                  bgcolor: "#fff",
                  height: { xs: "auto" },
                  //   border: "1px solid #d1cfcf",
                  borderRadius: "5px",
                  overflow: "hidden",
                  // padding: "10px",
                  padding: "10px 10px !important",
                }}
              >
                {selectedId ? (
                  <>
                    <VehiclesDetails
                      selectedId={selectedId}
                      onEditClick={() => handleEditVehicle(selectedId)}
                    />
                    <VehicleServiceHistory selectedId={selectedId} />
                  </>
                ) : (
                  <Box
                    sx={{
                      textAlign: "center",
                      padding: "20px",
                     color: "#4A4A4A",
                     fontWeight: 500,
                    }}
                  >
                    Please select a vehicle to see details
                  </Box>
                )}
              </Box>
            </Box>
          </Container>
        </Grid>
      </Grid>
    </>
  );
};

export default ClientAdminVehicles;
